import { BaseSectionCreator } from './baseSectionCreator';
import { IItemSection, ItemSection, SectionType } from '../itemSection';
import { Product } from '@/store/modules/product';
import store from '@/store';
import Element, { ElementType } from '../element';
import { bedLegs } from '../legs/bedLegs';
import { ShaderLiftedFrame } from '../shaders/bed/shader_lifted_frame';
import { ShaderFloorFrame } from '../shaders/bed/shader_floor_frame';
import { ChangeBedColorCommand, BedElementType } from '../command/changeBedColorCommand';
import { ShaderFloorWithFlexibleSlatsFrame } from '../shaders/bed/shader_floor_with_flexible_slats';
import { IShader } from '../shaders/shader';

export class BedSectionCreator extends BaseSectionCreator {

    protected sections: IItemSection[] = [
        new ItemSection(SectionType.BODY_COLOR, 'Kolor korpusu', []),
        new ItemSection(SectionType.WALL_COLOR, '', []),
        new ItemSection(SectionType.LEGS, 'nóżki', []),
        new ItemSection(SectionType.FRAME, '', []),
    ];

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public create(product: Product): IItemSection[] {
        this.applyLanguage();
        const furnitureShaders = store.getters.shaders.furniture;
        this.updateShaderSection(SectionType.BODY_COLOR, ElementType.BODY, furnitureShaders, (shader) => {
            this.scenePreview.loadNewSceneState(() => {
                const command = new ChangeBedColorCommand(
                    this.scenePreview,
                    this.scenePreview.elements.filter((x: Element) => x.type === ElementType.BODY),
                    shader,
                    BedElementType.BODY,
                );
                this.scenePreview.addCommand(command);
            });
        });
        this.updateShaderSection(SectionType.WALL_COLOR, ElementType.WALL, furnitureShaders, (shader) => {
            this.scenePreview.loadNewSceneState(() => {
                const command = new ChangeBedColorCommand(
                    this.scenePreview,
                    this.scenePreview.elements.filter((x: Element) => x.type === ElementType.BEDHEAD),
                    shader,
                    BedElementType.WALL,
                );
                this.scenePreview.addCommand(command);
            });
        });
        this.updateLegsSection(product, bedLegs);
        this.updateFrameSection();
        return this.sections;
    }

    protected applyLanguage(): void {
        this.getSectionByType(SectionType.BODY_COLOR).text = this.scenePreview.$t('bedBodyColor');
        this.getSectionByType(SectionType.WALL_COLOR).text = this.scenePreview.$t('bedWallColor');
        this.getSectionByType(SectionType.LEGS).text = this.scenePreview.$t('legs');
        this.getSectionByType(SectionType.FRAME).text = this.scenePreview.$t('frame');
    }

    private updateFrameSection() {
        const section = this.getSectionByType(SectionType.FRAME);
        const liftedFrameShader = new ShaderLiftedFrame();
        const floorWithSlexibleSlatsShader = new ShaderFloorWithFlexibleSlatsFrame();
        const floorFrameShader = new ShaderFloorFrame();
        section.params = [
            this.createParam(
                liftedFrameShader,
                liftedFrameShader.avatar,
                () => {
                    this.selectFrame(liftedFrameShader);
                },
                () => store.getters.shaders.selectedFrame.key === liftedFrameShader.key,
                () => false,
            ),
            this.createParam(
                floorWithSlexibleSlatsShader,
                floorWithSlexibleSlatsShader.avatar,
                () => {
                    this.selectFrame(floorWithSlexibleSlatsShader);
                },
                () => store.getters.shaders.selectedFrame.key === floorWithSlexibleSlatsShader.key,
                () => false,
            ),
            this.createParam(
                floorFrameShader,
                floorFrameShader.avatar,
                () => {
                    this.selectFrame(floorFrameShader);
                },
                () => store.getters.shaders.selectedFrame.key === floorFrameShader.key,
                () => false,
            ),
        ];
    }

    private selectFrame(frame: IShader) {
        store.commit('selectFrame', frame);
        store.dispatch('sapCalculate');
    }
}
